import { render, staticRenderFns } from "./TElegant.vue?vue&type=template&id=5c197b27&scoped=true&"
import script from "./TElegant.vue?vue&type=script&lang=js&"
export * from "./TElegant.vue?vue&type=script&lang=js&"
import style0 from "./TElegant.vue?vue&type=style&index=0&id=5c197b27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c197b27",
  null
  
)

export default component.exports